module.exports = __webpack_public_path__ + "static/media/logo.fbb61403.png";